import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Indicadores from './pages/Indicadores';
import GestorFormulario from './pages/GestorFormulario';
import IndicadoresFrom from './pages/IndicadoresFrom';
import PerfilesPage from './pages/perfiles';
import MapaCauca from './components/MapaCauca/MapaCauca';
import 'antd/dist/reset.css';



const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          {/* Ruta predeterminada redirige a la página Indicadores */}
          <Route path="/" element={<Navigate to="/indicadores" />} />

          {/* Ruta que muestra directamente la página de Indicadores */}
          <Route path="/indicadores" element={<Indicadores />} />
          <Route path="/gestor-formulario" element={<GestorFormulario />} />
          <Route path="/indicadores/tabla" element={<IndicadoresFrom />} />
          <Route path="/perfiles" element={<PerfilesPage />} />
          <Route path="/mapa" element={<MapaCauca />} />

        </Routes>
      </div>
    </Router>
  );
};

export default App;